import { useEffect } from 'react';

import { check_circle, icon_circles } from '@Assets';
import Modal from './modal';

interface ModalSuccessProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const ModalSuccess = ({ isOpen, onClose, children }: ModalSuccessProps) => {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, [isOpen]);

  return (
    <Modal modalOpen={isOpen} closeModal={onClose} className="z-20">
      <div>
        <div className="flex w-full justify-center h-full">
          <div className="relative -mt-3">
            <img src={icon_circles} alt="close_user" className="w-[360px] text-gray-200 ml-auto" />
            <div className="bg-primary left-[40%] top-[30%] p-[15px] flex flex-col rounded-md absolute">
              <img src={check_circle} alt="close_user" className="w-[40px] text-gray-200 ml-auto" />
            </div>
          </div>
        </div>
        {children}
      </div>
    </Modal>
  );
};

export default ModalSuccess;
